import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../reduxProvider';

const selectAuthSlice = createSelector(
  (state: RootState) => state.auth,
  (auth) => auth
);

export const selectAuthUserLoading = createSelector(selectAuthSlice, (auth) => auth.fetchingAuthUser);

export const selectAuthUser = createSelector(selectAuthSlice, (auth) => auth.user);

export const selectAuthUserDepartment = createSelector(selectAuthUser, (user) => user?.departments?.[0] ?? null);
